import { Alert } from '@zenid/web';
import { useId } from 'react';
import { css } from '../../../../styled-system/css';
import { flex } from '../../../../styled-system/patterns';

/** 統合が実質的に取り消せないことの確認。統合ログインへ進む画面で共通して用いる */
export const INTEGRATION_IRREVERSIBLE_MESSAGE = '一度統合したアカウントを再び分離することはできません';

type Props = {
  message: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function IntegrationConsent({ message, checked, onChange }: Props) {
  const checkboxId = useId();
  return (
    <div className={flex({ flexDirection: 'column', gap: '{spacing.16}' })}>
      <Alert type="warning">
        <p className={css({ textStyle: 'body.m.default', color: '{colors.text.main}' })}>{message}</p>
      </Alert>
      <div className={flex({ alignItems: 'center', gap: '{spacing.8}' })}>
        <input
          id={checkboxId}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className={css({ width: '20px', height: '20px', cursor: 'pointer', flexShrink: '0' })}
        />
        <label
          htmlFor={checkboxId}
          className={css({ textStyle: 'body.m.default', color: '{colors.text.main}', cursor: 'pointer' })}
        >
          上記の内容に同意します
        </label>
      </div>
    </div>
  );
}
